export default "__VITE_ASSET__601b77df__"